import { Component, inject } from '@angular/core';
import { MenuItem } from '@card-software/library';
import { RolesBootstrapService, Site, SiteBootstrapService, SiteService } from '@card-software/nexus-utilities';
import { NavigationEnd, Router } from '@angular/router';
import { UserAuthenticationService } from './services/user-authentication.service';
import { TranslateService } from '@ngx-translate/core';
import _ from 'lodash';
import { environment } from '@environments/environment';
import { MENU_ITEMS } from './app-menu';
import { MessageService } from 'primeng/api';
import { GlobalMessageUtil } from '@card-software/nexus-utilities';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private readonly siteBootstrapService = inject(SiteBootstrapService);
  private readonly rolesBootstrapService = inject(RolesBootstrapService);

  readonly environment = environment.environment;
  title = 'user-ui';
  isLoginPage = false;

  menuItems: MenuItem[] = MENU_ITEMS;

  constructor(
    private router: Router,
    private userAuthenticationService: UserAuthenticationService,
    private translate: TranslateService,
    private messageService: MessageService,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isLoginPage = _.includes(event.url, '/login');
      }
    });
    // The shared errorInterceptor toasts through the static GlobalMessageUtil, so it needs the MessageService.
    GlobalMessageUtil.init(this.messageService);
    const token = this.userAuthenticationService.getStoredJwtToken();
    if (token) {
      this.rolesBootstrapService.initializeRoles(token);
      this.siteBootstrapService.initializeSites(token);
    }

    // Inicializar idioma guardado
    const savedLang = localStorage.getItem('app_lang');
    if (savedLang) {
      this.translate.setDefaultLang(savedLang);
      this.translate.use(savedLang);
    } else {
      this.translate.setDefaultLang('en');
      this.translate.use('en');
    }
  }

  get isLoggedIn() {
    return this.userAuthenticationService.isUserAuthenticated;
  }

  get userLite() {
    return this.userAuthenticationService.userLite;
  }

  get userToken() {
    return this.userAuthenticationService.getStoredJwtToken() || '';
  }

  get sites(): Site[] {
    return SiteService.getSites();
  }

  get selectedSiteId(): string {
    return SiteService.getSelectedSiteId() || '';
  }

  onSiteChanged(siteId: string) {
    SiteService.setSelectedSite(siteId);
  }

  onLogout() {
    this.userAuthenticationService.logout();
  }

  changeLanguage(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('app_lang', lang);
  }
}
